<template>
  <a-button type="primary" :class="{active: selected}" :style="{minWidth: minWidth + 'px'}" @click="$emit('click')">{{title}}</a-button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    minWidth: {
      default: 65,
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
.options-bg .ant-btn-primary{
  font-size:12px;
  padding:0 10px;
  background-color: #404040;
  border-color: #2e2e2e;
}
.options-bg .active {
  // background-color: #1890ff;
  // border-color: #1890ff;
  background-color: #015C61;
  border-color: #015C61;
}
.options-bg .titleBtn.active {
  background-color: #7101ad;
  border-color: #7101ad;
}

</style>